import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Court, IState, ISport } from '../../models/court.model';
import { CoreService } from '../../services/core.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-court-popup',
  templateUrl: './court-popup.component.html',
  styleUrls: ['./court-popup.component.css'],
})
export class CourtPopupComponent {
  states: IState[] = [];
  sports: Array<ISport> = [];
  court: Court = {
    id: -1,
    name: '',
    address1: '',
    address2: '',
    city: '',
    zip: '',
    state: {
      id: -1,
      code: '',
      name: ''
    },
    numberOfCourt: null,
    sport: {
      id: -1,
      name: ''
    },
  }

  constructor(public dialogRef: MatDialogRef<CourtPopupComponent>, @Inject(MAT_DIALOG_DATA) public existingCourt: Court, private coreService: CoreService) {
    this.getStates();
    this.getSports();
    if (existingCourt) {
      existingCourt.state = existingCourt?.state ? existingCourt.state : this.court.state;
      this.court = existingCourt;
    }
  }
  onNumberOfCourtChange() {
    if (!this.court.numberOfCourt || this.court.numberOfCourt <= 0) {
      this.court.numberOfCourt = null;
    }
  }
  

  onNoClick(): void {
    this.dialogRef.close();
  }
  confirmAndClose() {
    this.dialogRef.close(this.court);
    Swal.fire({
      icon: "success",
      title: "Created Successfully!",
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 2000
    }).then((result) => {

    });
  }

  getStates() {
    this.coreService.isLoading.next(true);
    this.coreService.getApi('/api/Master/GetStates').subscribe({
      next: (res: any) => {
        this.coreService.isLoading.next(false);
        this.states = res;
      },
      error: (error) => {
        this.coreService.isLoading.next(false);
      },
    });
  }
  getSports() {
    this.coreService.isLoading.next(true);
    this.coreService.getApi('/api/Master/GetSports').subscribe({
      next: (res: any) => {
        this.coreService.isLoading.next(false);
        this.sports = res;
      },
      error: (error) => {
        this.coreService.isLoading.next(false);
      },
    });
  }

}
